import { BasicGiftCardProvider } from '@/src/common/contexts/BasicGiftCardContext'
import { getStaticPropsDataForPhysicalVisa } from '@/src/common/utilities/getStaticPropsDataForPhysicalVisa'
import { BuildACardPhysical } from '@/src/modules/build-a-card/physical/BuildACardPhysical'
import { BuilderComponent } from '@builder.io/react'
import type { InferGetStaticPropsType } from 'next'
import '../src/common/components/marketing/buttons/LinkButton.builder'
import '../src/common/components/marketing/cards/StaffBio.builder'
import '../src/common/components/marketing/headlines/HeadlineEyebrow.builder'
import '../src/common/components/marketing/reviews/StarRating.builder'
import '../src/common/components/marketing/text/FAQSection.builder'
import '../src/common/components/marketing/text/MulticolorText.builder'
import localFont from 'next/font/local'
import { PlasticGiftQuantityProvider } from '@/src/common/contexts/PlasticGiftQuantityContext'
import { getBuilderBannersOrPromos } from '@/src/common/queries/getBuilderBannersOrPromos'

const handwrittenFont = localFont({
    src: '../public/fonts/hwLindsey.ttf',
    variable: '--font-handwrytten',
})

export default function Page(
    props: InferGetStaticPropsType<typeof getStaticProps>
) {
    return (
        <BasicGiftCardProvider
            defaultImage={props.defaultImages}
            predesigns={props.predesigns}
            greetingCards={props.greetingCard}
            defaultToPredesign={false}
            handwrittenEnabled={props.is_handwritten_enabled}
            handwrittenFontClassName={handwrittenFont.className}
        >
            <PlasticGiftQuantityProvider productUuid={props.product.uuid ?? ''}>
                <BuildACardPhysical />
                <BuilderComponent model="page" content={props.content} />
            </PlasticGiftQuantityProvider>
        </BasicGiftCardProvider>
    )
}

export async function getStaticProps() {
    const staticPropsData = await getStaticPropsDataForPhysicalVisa(
        'personalized-visa-gift-card'
    )
    const { consumerData: consumerBanner } = await getBuilderBannersOrPromos(
        true
    )
    // Pass data to the page via props
    return {
        props: { ...staticPropsData, consumerBanner },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in at most once every 30 seconds
        revalidate: 30,
    }
}
